import {Navigate} from "react-router-dom";

interface ContentProps {
    redirectPage: string;
}

export default function Index({redirectPage}: ContentProps) {
    const navigateState = {from: {pathname: location.pathname, search: location.search, hash: location.hash}};
    return (<Navigate to={redirectPage} replace state={navigateState}/>);
}

